// extracted by mini-css-extract-plugin
export default {"hero-image":"content_hero-image__ltgCV","cta-box":"content_cta-box__SXIak","add-section":"content_add-section__8GV5o"};